<template>
  <m-modal
    :visible="visible"
    :title="$t('Common.action.preview')"
    width="90%"
    @cancel="handleClose"
    :footer="null"
    :key="modalKey"
  >
    <m-spin :spinning="loading">
      <vue-pdf-embed
        v-if="pdfSource"
        ref="pdfRef"
        :source="pdfSource"
        :page="currentPage"
        @rendered="handleRendered"
        @error="handleError"
        :key="pdfKey"
        style="width: 100%; border: 1px solid #eee"
      />

      <div v-if="error" class="error-message">
        {{ error }}
      </div>
    </m-spin>

    <!-- 分頁控制 -->
    <div class="pagination" v-if="pageCount > 1 && !error">
      <m-button
        type="primary"
        icon="left"
        circle
        @click="prevPage"
        :disabled="currentPage <= 1"
      ></m-button>
      <span class="page-info">{{ currentPage }}/{{ pageCount }}</span>
      <m-button
        type="primary"
        icon="right"
        circle
        @click="nextPage"
        :disabled="currentPage >= pageCount"
      ></m-button>
    </div>
  </m-modal>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  components: { VuePdfEmbed },
  props: {
    visible: Boolean,
    title: String,
    blobUrl: String,
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      loading: true,
      error: null,
      pdfSource: null,
      pdfKey: 0, // 用於強制重新渲染PDF
      modalKey: 0, // 用於強制重新創建模態
    };
  },
  watch: {
    blobUrl: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.resetState(); // 先重置狀態
          this.loadPdf(newVal);
        }
      },
    },
    visible(val) {
      if (val) {
        this.modalKey++; // 每次打開模態時改變key
      }
    },
  },
  methods: {
    // 重置所有狀態
    resetState() {
      this.currentPage = 1;
      this.pageCount = 0;
      this.loading = true;
      this.error = null;
      this.pdfKey++; // 強制PDF組件重新渲染

      // 清理之前的blob URL
      if (this.pdfSource && this.pdfSource.startsWith('blob:')) {
        URL.revokeObjectURL(this.pdfSource);
      }
      this.pdfSource = null;
    },

    async loadPdf(blobUrl) {
      try {
        this.resetState();

        // 方法1：直接使用blob URL
        this.pdfSource = blobUrl;

        // 方法2：轉換為Uint8Array（兼容性更好）
        // const response = await fetch(blobUrl)
        // const blob = await response.blob()
        // const arrayBuffer = await blob.arrayBuffer()
        // this.pdfSource = new Uint8Array(arrayBuffer)
      } catch (err) {
        this.error = 'PDF加載失敗: ' + err.message;
        console.error('PDF加載錯誤:', err);
        this.loading = false;
      }
    },

    handleRendered() {
      this.loading = false;
      this.pageCount = this.$refs.pdfRef?.pageCount || 0;
    },

    handleError(err) {
      this.loading = false;
      this.error = 'PDF渲染失敗: ' + err.message;
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    nextPage() {
      if (this.currentPage < this.pageCount) this.currentPage++;
    },

    handleClose() {
      this.resetState();
      this.$emit('close');
    },
  },

  beforeDestroy() {
    this.resetState();
  },
};
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  text-align: center;
}
.page-info {
  margin: 0 16px;
}
.error-message {
  color: red;
  text-align: center;
  padding: 20px;
}
</style>